export default __webpack_public_path__ + "6381e0775f49919f628edc9e8f3aeb7a.png";